import { render, staticRenderFns } from "./SalaryPaid.vue?vue&type=template&id=ee5495fa&scoped=true"
import script from "./SalaryPaid.vue?vue&type=script&lang=js"
export * from "./SalaryPaid.vue?vue&type=script&lang=js"
import style0 from "./SalaryPaid.vue?vue&type=style&index=0&id=ee5495fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5495fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee5495fa')) {
      api.createRecord('ee5495fa', component.options)
    } else {
      api.reload('ee5495fa', component.options)
    }
    module.hot.accept("./SalaryPaid.vue?vue&type=template&id=ee5495fa&scoped=true", function () {
      api.rerender('ee5495fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryPaid.vue"
export default component.exports